import { Account } from 'vopay';

export const LIMIT_PERIODS = ['Daily', 'Weekly', 'Monthly'] as const;

export type LimitPeriod = (typeof LIMIT_PERIODS)[number];

export type LimitAmounts = Record<LimitPeriod, number | null>;

/** Velocity amounts arrive as decimal strings, or null/absent when no limit is configured. */
export function toLimitAmount(value: unknown): number | null {
  if (value === null || value === undefined || value === '') return null;

  const amount = typeof value === 'number' ? value : parseFloat(String(value));

  return Number.isFinite(amount) ? amount : null;
}

/**
 * The account's outbound velocity limits, read off its permission fields. The card follows the
 * account page's "Outbound Global Velocities" section (Figma), which is the direction the
 * Daily / Weekly / Monthly amount limits are defined for.
 */
export function getOutboundLimits(account: Account): LimitAmounts {
  return {
    Daily: toLimitAmount(account.DailyLimitOutboundAmount),
    Weekly: toLimitAmount(account.WeeklyLimitOutboundAmount),
    Monthly: toLimitAmount(account.MonthlyLimitOutboundAmount),
  };
}
